//fill 0 in front if time part less then 10
export default function formatTime(timePart) {
  return timePart < 10 ? "0"+timePart :timePart;
}